import { Center, Loader, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { isNonNullish, isNullish } from 'remeda';
import { useLoadLegacyPortalLink } from 'shared/hooks/use-load-legacy-portal-link';

const PAYMENT_RESULT_PARAMS: ReadonlyArray<string> = ['paymentSucceeded', 'paymentError'];

export const LegacyPortalRedirect = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { search } = useLocation();
  const { legacyPortalLink, legacyPortalLinkError } = useLoadLegacyPortalLink({
    invoiceId: id,
    token: new URLSearchParams(search).get('token') ?? '',
  });

  const invalidLinkMessage = t(i18nKeys.DEBTOR.REACTION.LINK_NO_LONGER_VALID);
  if (isNonNullish(legacyPortalLinkError)) return <InvalidLink message={invalidLinkMessage} />;
  if (isNullish(legacyPortalLink)) return <FullPageLoader />;
  if (legacyPortalLink.url === null) return <InvalidLink message={invalidLinkMessage} />;
  return <RedirectTo url={withPaymentResult(legacyPortalLink.url, search)} />;
};

const RedirectTo = ({ url }: { url: string }) => {
  useEffect(() => {
    window.location.replace(url);
  }, [url]);

  return <FullPageLoader />;
};

const InvalidLink = ({ message }: { message: string }) => (
  <Center h="100vh" p="md">
    <Text ta="center">{message}</Text>
  </Center>
);

const FullPageLoader = () => (
  <Center h="100vh">
    <Loader />
  </Center>
);

function withPaymentResult(portalLink: string, search: string): string {
  const searchParams = new URLSearchParams(search);
  const url = new URL(portalLink);
  PAYMENT_RESULT_PARAMS.forEach(param => {
    const value = searchParams.get(param);
    if (value !== null) url.searchParams.set(param, value);
  });
  return url.toString();
}
